// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"109":"6014f104","960":"7254a7c8"}[chunkId] + ".chunk.css";
};